interface QueueJob {
  id: string;
  handler: () => Promise<void> | void;
}

export const useQueueStore = defineStore('queue-store', () => {
  const pending = ref<QueueJob[]>([]);
  const active = ref<QueueJob>();
  const completed = ref<QueueJob[]>([]);

  watch(active, async (job) => {
    if (job) {
      try {
        await job.handler();
      } catch (error) {
        console.error(`Queue job ${job.id} failed`, error);
      }
      startNextJob();
    }
  });

  function addJob(job: QueueJob) {
    const exist =
      pending.value.find((j) => j.id === job.id) ||
      active.value?.id === job.id ||
      completed.value.find((j) => j.id === job.id);

    if (exist) return;

    pending.value.push(job);
    if (!active.value) startNextJob();
  }

  function startNextJob() {
    if (active.value) completed.value.push(active.value);

    if (pending.value.length > 0) {
      active.value = pending.value[0];
      pending.value.shift();
    } else {
      active.value = undefined;
    }
  }

  function clearPendingJobs() {
    pending.value = [];
  }

  function clearCompletedJobs() {
    completed.value = [];
  }

  function cancelJob(index: number) {
    pending.value.splice(index, 1);
  }

  return {
    pending,
    completed,
    active,
    addJob,
    startNextJob,
    clearPendingJobs,
    clearCompletedJobs,
    cancelJob,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useQueueStore, import.meta.hot));
}
